import Axios from "axios";
import handleAjaxError from "../../helpers/handleAjaxError";
import {toUrl} from "../../helpers/url";
import {initProjectSelect} from "../../common/projectSelect";
import {deleteConfirmation, handleAjaxSuccess} from "../../helpers/SwalHelper";

let project = null;
let isCustomerView = false;
let designBoardContainer = null;

function initDesignBoardIndex(_isCustomerView = false) {
	if (window.project) {
		project = window.project;
	}

	isCustomerView = _isCustomerView;
	if (!isCustomerView) {
		initProjectSelect();
	}

	document.querySelectorAll('.delete-post-button').forEach(button => {
		button.onclick = e => deletePost(e.target.dataset);
	});

	designBoardContainer = document.querySelector('.design-board-container');


	document.querySelector('select[name=category_id]').onchange = e => filterPostsByCategory(e.target.value);

}

function filterPostsByCategory(categoryId) {
	if (categoryId) {
		designBoardContainer.querySelectorAll('.post').forEach(postCard => {
			// noinspection EqualityComparisonWithCoercionJS
			if (postCard.dataset.categoryId == categoryId) {
				postCard.parentElement.classList.remove('d-none');
			} else {
				postCard.parentElement.classList.add('d-none');
			}
		});
	} else {
		designBoardContainer.querySelectorAll('.post').forEach(postCard => {
			postCard.parentElement.classList.remove('d-none');
		});
	}

	const hiddenPosts = designBoardContainer.querySelectorAll('.d-none > .post').length;
	const allPosts = designBoardContainer.querySelectorAll('.post').length;

	if (hiddenPosts === allPosts) {
		designBoardContainer.classList.add('d-none');
		document.querySelector('.empty-message').classList.remove('d-none');

	} else {
		designBoardContainer.classList.remove('d-none');
		document.querySelector('.empty-message').classList.add('d-none');
	}

}

function deletePost(data) {
	deleteConfirmation('Are you sure you want to delete this post')
		.then((result) => {
			if (result.value) {
				loading();
				let url = toUrl(`/admin/design-board/${data.id}`);

				if (isCustomerView) {
					url = toUrl(`/design-board/${data.id}`);
				}
				Axios.delete(url)
					.then(handleAjaxSuccess)
					.catch(handleAjaxError)
					.finally(stopLoading);
			}
		})
}

export {
	initDesignBoardIndex
}
